import 'cropperjs/dist/cropper.css';

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { Cropper } from 'react-cropper';

type ModalCropImageProps = {
  isOpen: boolean;
  onClose: () => void;
  onImageCropped: (imageCropped: string) => void;
  setImage?: any;
  image: any;
  //setSrc: any;
  aspect?: number;
  //action?: any;
  //setAction?: any;
};

export const ModalCropImage = ({
  isOpen,
  onClose,
  onImageCropped,
  image,
  aspect
}: ModalCropImageProps) => {
  const [cropData, setCropData] = useState('#');

  const [cropper, setCropper] = useState<Cropper>();

  const imageRef = useRef<HTMLImageElement>(null);

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      setCropData(cropper.getCroppedCanvas().toDataURL());
    }
  };

  useEffect(() => {
    if (typeof cropper !== 'undefined') {
      onImageCropped(cropData);
    }
  }, [cropData]);

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW="40vw" borderRadius="1.5rem">
        <ModalHeader>Redimensionar imagem</ModalHeader>
        <ModalCloseButton onClick={() => onClose()} />
        <ModalBody display="flex" justifyContent="center" alignItems="center">
          <Cropper
            style={{ height: 300, width: '100%' }}
            initialAspectRatio={aspect}
            aspectRatio={aspect}
            preview=".img-preview"
            src={image}
            ref={imageRef}
            viewMode={1}
            guides={true}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            onInitialized={(instance) => {
              setCropper(instance);
            }}
          />
        </ModalBody>

        <ModalFooter justifyContent="space-between">
          <Button
            border="1px solid #001e64"
            bg="#fff"
            w="10rem"
            h="3rem"
            borderRadius="2rem"
            color="#001e64"
            onClick={() => onClose()}
          >
            Cancelar
          </Button>
          <Button
            border="1px solid #FA6B25"
            bg="#FA6B25"
            w="10rem"
            h="3rem"
            borderRadius="2rem"
            color="#fff"
            colorScheme="orange"
            onClick={() => {
              getCropData();
              onClose();
            }}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
